import { render, staticRenderFns } from "./Whitepaper.vue?vue&type=template&id=127eba3d&scoped=true"
import script from "./Whitepaper.vue?vue&type=script&lang=js"
export * from "./Whitepaper.vue?vue&type=script&lang=js"
import style0 from "./Whitepaper.vue?vue&type=style&index=0&id=127eba3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127eba3d",
  null
  
)

export default component.exports